import { supabase } from '../lib/supabase'
import type { Task } from '../types/index'

function rowToTask(r: Record<string, unknown>): Task {
  return {
    id:          r.id as string,
    title:       r.title as string,
    description: (r.description as string) || '',
    priority:    (r.priority as Task['priority']) || 'medium',
    status:      (r.status as Task['status']) || 'todo',
    assignee:    (r.assignee as string) || '',
    projectId:   r.project_id as string | undefined,
    projectName: r.project_name as string | undefined,
    dueDate:     (r.due_date as string) || '',
    tags:        (r.tags as string[]) || [],
    createdAt:   r.created_at as string,
  }
}

export async function getTasks(): Promise<Task[]> {
  const { data, error } = await supabase.from('tasks').select('*').order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map(rowToTask)
}

export async function createTask(t: Omit<Task, 'id' | 'createdAt'>): Promise<Task> {
  const { data, error } = await supabase.from('tasks').insert({
    title: t.title, description: t.description, priority: t.priority,
    status: t.status, assignee: t.assignee, project_id: t.projectId || null,
    project_name: t.projectName, due_date: t.dueDate, tags: t.tags,
  }).select().single()
  if (error) throw error
  return rowToTask(data)
}

export async function updateTask(id: string, t: Partial<Task>): Promise<void> {
  const updates: Record<string, unknown> = {}
  if (t.title       !== undefined) updates.title        = t.title
  if (t.description !== undefined) updates.description  = t.description
  if (t.priority    !== undefined) updates.priority     = t.priority
  if (t.status      !== undefined) updates.status       = t.status
  if (t.assignee    !== undefined) updates.assignee     = t.assignee
  if (t.projectId   !== undefined) updates.project_id   = t.projectId || null
  if (t.projectName !== undefined) updates.project_name = t.projectName
  if (t.dueDate     !== undefined) updates.due_date     = t.dueDate
  if (t.tags        !== undefined) updates.tags         = t.tags
  const { error } = await supabase.from('tasks').update(updates).eq('id', id)
  if (error) throw error
}

export async function deleteTask(id: string): Promise<void> {
  const { error } = await supabase.from('tasks').delete().eq('id', id)
  if (error) throw error
}
